import styled from '@emotion/styled';
import { ChevronIcon } from 'src/ui/assets/icons/arrow/ChevronIcon';
import { withConfig } from 'src/withConfig';

export const SectionHeader = withConfig(theme => styled('header', { label: 'SectionHeader' })`
    background: ${theme.star.raceSectionHeader.bgColor};
    border: 1px solid ${theme.star.raceSectionHeader.borderColor};
    display: flex;
    flex-flow: row wrap;
    gap: 16px;
    padding: 16px;
`);

export const BreadcrumbRow = styled('div', { label: 'BreadcrumbRow' })`
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    width: 100%;
`;

export const ChevronLeftButton = styled(ChevronIcon, { label: 'ChevronLeftButton' })`
    align-self: start;
    cursor: pointer;
    fill: currentcolor;
    flex: 0 0 24px;
    padding: 4px;
    width: 24px;
`;

export const SectionHeaderColumnWrapper = styled('div', { label: 'SectionHeaderColumnWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    gap: 4px;
`;

export const SectionHeaderColumn = styled('div', { label: 'SectionHeaderColumn' })`
    display: flex;
    flex-flow: row wrap;
    width: 100%;
`;

export const MetaRacePlace = withConfig(theme => styled('h4', { label: 'MetaRacePlace' })`
    color: ${theme.star.raceSectionHeader.txtColor};
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.5;
    margin: 0;
`);

export const RaceMeta = withConfig(theme => styled('span', { label: 'RaceMeta' })`
    color: ${theme.star.raceSectionHeader.txtColorSecondary};
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
    &::after {
        content: '|';
        margin: 0 4px;
    }
    &:last-of-type,
    &:only-of-type {
        &::after {
            content: none;
        }
    }
`);
